var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityMedicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6791 0.431501C35.1757 3.03239 37.5055 12.3514 34.9153 21.0024C32.3251 29.6535 25.7958 34.3606 17.2992 31.7597C8.8026 29.1588 -2.2049 24.7834 0.3853 16.1324C2.9755 7.48131 18.1825 -2.16939 26.6791 0.431501Z",
    fill: "#E6E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4442 7.84704C25.186 5.58778 21.7412 5.3715 19.7507 7.36186L14.3295 12.7835L10.5784 16.5338C8.58787 18.5248 8.80475 21.9689 11.0629 24.2288C13.3217 26.4868 16.7666 26.7031 18.757 24.7133L22.5076 20.9623L27.9294 15.5413C29.9205 13.5504 29.703 10.1058 27.4442 7.84704ZM17.7903 23.7454C16.3359 25.1997 13.7524 24.9817 12.0309 23.2609C10.31 21.5395 10.0919 18.9567 11.5463 17.5017L15.2968 13.7513L21.5408 19.9951L17.7903 23.7454Z",
    fill: "#372C65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3808 25.1104C16.1046 27.3726 12.4271 27.3669 10.1579 25.0976C7.86806 22.8078 7.88603 19.0898 10.1979 16.8223L14.7852 12.3228L22.8182 20.7004L18.3808 25.1104Z",
    fill: "#8C82B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityMedicationIcon);
export default __webpack_public_path__ + "static/media/activity-medication-icon.2bd342a0a5143b55009275714d19de86.svg";
export { ForwardRef as ReactComponent };